import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { actionHistory } from '../../../store';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Freezing extends Modifier {
  static readonly baseTitle = 'Freezing';
  static readonly baseText =
    'On taking damage, if health is less than stacks, shatter and die. Fade 1 for each technique used.';
  static readonly baseIcon = 'ice';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Last;

  // Instance properties that can change
  title = Freezing.baseTitle;
  text = Freezing.baseText;
  icon = Freezing.baseIcon;
  tags: Array<ModifierTags> = [...Freezing.baseTags];
  priority = Freezing.basePriority;

  update(stacks: number) {
    if (stacks) {
      actionHistory.push(`Added ${stacks} ${this.type} to ${this.owner.title}.`);
      this.stacks += stacks;
    }

    this.checkDied();
  }

  public checkDied() {
    if (this.stacks >= this.owner.healthCurrent) {
      const damage: Damage = {
        value: this.stacks,
        target: this.owner,
        source: this.owner,
        dice: [],
      };

      actionHistory.push('Shatter');
      healthRemove(damage);
    }
  }

  useTechnique() {
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Freezing, Freezing);
